import React from 'react';
import {FormattedMessage} from 'react-intl';
import Breadcrumbs from 'react-router-breadcrumbs';
import Link from '../../routing/components/Link';
import stringHelper from '../../../helpers/stringHelper';

const BreadCrumb = ({params, routes, labels}) => {
  function customResolver(keyValue, text, routePath, route) {
    let label = null;
    if (route.path.indexOf(":annotationId") > -1) {
      label = labels[params.annotationId];
    }
    if (route.path.indexOf(":elementId") > -1) {
      label = labels[params.elementId];
    }
    if (route.path.indexOf(":articleId" || route.path.indexOf(":conceptId") > -1) > -1) {
      label = labels[params.articleId];
    }
    if (route.path.indexOf(":structureId") > -1 || route.path.indexOf(":publicationId") > -1) {
      label = labels[params.structureId];
    }

    // TODO add intermedia breadcrumbs, resolve print when in printqueue

    if (label) {
      return stringHelper.truncate(label, 60, true);
    }

    return <FormattedMessage id={text}/>;
  }

  function createLink(link, key, text, index, routes) {
    let lastActiveRoute = routes.length - 1;
    while (lastActiveRoute > 0 && routes[lastActiveRoute].breadcrumbIgnore) {
      lastActiveRoute--;
    }
    return (<Link className={index === lastActiveRoute ? 'active' : null} url={routes[index].link ? routes[index].link : link} key={`${index}-${link}`}>{text}</Link>);
  }

  function customSeparator(crumbElement, index, array) {
    return <span key={`separator-${index}`}> &gt; </span>;
  }

  return (<Breadcrumbs resolver={customResolver} createLink={createLink} params={params} routes={routes}
                       createSeparator={customSeparator} className="breadcrumb"/>);
};

BreadCrumb.propTypes = {
  labels: React.PropTypes.object,
  params: React.PropTypes.object,
  routes: React.PropTypes.array
};

BreadCrumb.defaultProps = {
  labels: {}
};

export default BreadCrumb;



/** WEBPACK FOOTER **
 ** ./src/modules/breadcrumb/components/BreadCrumb.js
 **/